import React from "react";
import { Lock, Move3d, Rotate3d, Scaling } from "lucide-react";
import { usePhysicsStore } from "../../stores/physicsStore";
import { useTransformGizmoControls } from "../property-panels/useTransformGizmoControls";
import { RotationGizmoIcon } from "../ui/Icons";
import { TOOLBAR_ICON_CLASS } from "./toolbarConstants";
import { ToolButton } from "./toolbarUi";

function TransformToolPrimary({ active, onClick }) {
  const isPhysicsRunning = usePhysicsStore((state) => state.isRunning);
  const { showPositionGizmo, showRotationGizmo, showScaleGizmo } = useTransformGizmoControls({
    disabled: isPhysicsRunning,
    enableShortcuts: false,
    enableScale: true,
  });

  const ActiveIcon = isPhysicsRunning
    ? Lock
    : showPositionGizmo
      ? Move3d
      : showRotationGizmo
        ? RotationGizmoIcon
        : showScaleGizmo
          ? Scaling
          : Rotate3d;

  return (
    <ToolButton
      active={active}
      className={isPhysicsRunning ? "viewport-toolbar-transform-physics-lock" : ""}
      label={
        isPhysicsRunning
          ? "Transform — expand to view gizmos (stop physics to use them)"
          : "Transform"
      }
      onClick={onClick}
    >
      <ActiveIcon className={TOOLBAR_ICON_CLASS} />
    </ToolButton>
  );
}

function TransformToolSubmenu() {
  const isPhysicsRunning = usePhysicsStore((state) => state.isRunning);
  const {
    showPositionGizmo,
    showRotationGizmo,
    showScaleGizmo,
    togglePositionGizmo,
    toggleRotationGizmo,
    toggleScaleGizmo,
  } = useTransformGizmoControls({
    disabled: isPhysicsRunning,
    enableShortcuts: false,
    enableScale: true,
  });

  return (
    <>
      <ToolButton
        active={showPositionGizmo}
        disabled={isPhysicsRunning}
        className={isPhysicsRunning ? "viewport-toolbar-button--physics-authoring-submenu" : ""}
        showPhysicsOutlineLock={isPhysicsRunning}
        label={isPhysicsRunning ? "Stop physics to edit transforms" : "Move gizmo (T)"}
        onClick={togglePositionGizmo}
        showOffSlash={!showPositionGizmo}
      >
        <Move3d className={TOOLBAR_ICON_CLASS} />
      </ToolButton>
      <ToolButton
        active={showRotationGizmo}
        disabled={isPhysicsRunning}
        className={isPhysicsRunning ? "viewport-toolbar-button--physics-authoring-submenu" : ""}
        showPhysicsOutlineLock={isPhysicsRunning}
        label={isPhysicsRunning ? "Stop physics to edit transforms" : "Rotate gizmo (R)"}
        onClick={toggleRotationGizmo}
        showOffSlash={!showRotationGizmo}
      >
        <RotationGizmoIcon className={TOOLBAR_ICON_CLASS} />
      </ToolButton>
      <ToolButton
        active={showScaleGizmo}
        disabled={isPhysicsRunning}
        className={isPhysicsRunning ? "viewport-toolbar-button--physics-authoring-submenu" : ""}
        showPhysicsOutlineLock={isPhysicsRunning}
        label={isPhysicsRunning ? "Stop physics to edit transforms" : "Scale gizmo"}
        onClick={toggleScaleGizmo}
        showOffSlash={!showScaleGizmo}
      >
        <Scaling className={TOOLBAR_ICON_CLASS} />
      </ToolButton>
    </>
  );
}

export { TransformToolPrimary, TransformToolSubmenu };
